if (window.Handlebars) {
	Handlebars.registerHelper("eq", function(v1, v2) {
		return v1 === v2;
	});
	Handlebars.registerHelper("ne", function(v1, v2) {
		return v1 !== v2;
	});
	Handlebars.registerHelper("lt", function(v1, v2) {
		return v1 < v2;
	});
	Handlebars.registerHelper("gt", function(v1, v2) {
		return v1 > v2;
	});
	Handlebars.registerHelper("lte", function(v1, v2) {
		return v1 <= v2;
	});
	Handlebars.registerHelper("gte", function(v1, v2) {
		return v1 >= v2;
	});
	Handlebars.registerHelper("and", function(v1, v2) {
		return v1 && v2;
	});
	Handlebars.registerHelper("or", function(v1, v2) {
		return v1 || v2;
	});
	Handlebars.registerHelper("isNull", function(v1) {
		return v1 == null;
	});
	Handlebars.registerHelper("isNotNull", function(v1) {
		return v1 != null;
	});
	Handlebars.registerHelper("not", function(v1) {
		return !v1;
	});
}


// WEBPACK FOOTER //
// ./../../../rairadio/template/helpers/conditional-helpers.js